import { MindBranchEmun } from './const';

export const MindNodeColors = {
  [MindBranchEmun.PARENT]: {
    default: '#e5e7eb',
    main: '#242935',
    secondary: '#242935',
  },
  [MindBranchEmun.FIRST]: {
    default: '#323142',
    main: '#d1aaff',
    secondary: '#e5e7eb',
  },
  [MindBranchEmun.SECOND]: {
    default: '#e5e7eb',
    main: '#FFE890',
    secondary: '#393A34',
  },
  [MindBranchEmun.THIRD]: {
    default: '#e5e7eb',
    main: '#B0ECFF',
    secondary: '#303A43',
  },
  [MindBranchEmun.FOURTH]: {
    default: '#e5e7eb',
    main: '#FFF9D8',
    secondary: '#2C2E32',
  },
  [MindBranchEmun.FIFTH]: {
    default: '#e5e7eb',
    main: '#A2E2A9',
    secondary: '#2E3837',
  },
  [MindBranchEmun.SIXTH]: {
    default: '#e5e7eb',
    main: '#FFB3B3',
    secondary: '#383238',
  },
};

const childDefaultStyles = {
  borderColor: null,
  padding: 5,
  borderRadius: 100,
};

const subchildDefaultStyles = {
  padding: 5,
  borderRadius: 100,
  fontSize: 8,
};

const subSubchildDefaultStyles = {
  bgColor: 'transparent',
  borderColor: null,
  fontSize: 8,
  width: 140,
};

export const nodeStylesConfig: Record<
  string,
  {
    bgColor: string | null;
    textColor: string | null;
    borderColor: string | null;
    padding?: number;
    fontSize?: number;
    width?: number;
    borderRadius?: number;
  }
> = {
  parent: {
    bgColor: MindNodeColors[MindBranchEmun.PARENT].main,
    textColor: MindNodeColors[MindBranchEmun.PARENT].default,
    borderColor: MindNodeColors[MindBranchEmun.PARENT].secondary,
    padding: 10,
    fontSize: 11,
    width: 100,
    borderRadius: 10,
  },

  // First-layer children
  'child-0': {
    ...childDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIRST].main,
    textColor: MindNodeColors[MindBranchEmun.FIRST].default,
  },
  'child-1': {
    ...childDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SECOND].main,
    textColor: '#000000',
  },
  'child-2': {
    ...childDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.THIRD].main,
    textColor: MindNodeColors[MindBranchEmun.THIRD].secondary,
  },
  'child-3': {
    ...childDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FOURTH].main,
    textColor: MindNodeColors[MindBranchEmun.FOURTH].secondary,
  },
  'child-4': {
    ...childDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIFTH].main,
    textColor: MindNodeColors[MindBranchEmun.FIFTH].secondary,
  },
  'child-5': {
    ...childDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SIXTH].main,
    textColor: MindNodeColors[MindBranchEmun.SIXTH].secondary,
  },

  // Subchildren
  'subchild-0-0': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIRST].default,
    textColor: MindNodeColors[MindBranchEmun.FIRST].secondary,
    borderColor: MindNodeColors[MindBranchEmun.FIRST].main,
  },
  'subchild-0-1': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIRST].default,
    textColor: MindNodeColors[MindBranchEmun.FIRST].secondary,
    borderColor: MindNodeColors[MindBranchEmun.FIRST].main,
  },
  'subchild-0-2': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIRST].default,
    textColor: MindNodeColors[MindBranchEmun.FIRST].secondary,
    borderColor: MindNodeColors[MindBranchEmun.FIRST].main,
  },

  'subchild-1-0': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SECOND].secondary,
    textColor: MindNodeColors[MindBranchEmun.SECOND].default,
    borderColor: MindNodeColors[MindBranchEmun.SECOND].main,
  },
  'subchild-1-1': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SECOND].secondary,
    textColor: MindNodeColors[MindBranchEmun.SECOND].default,
    borderColor: MindNodeColors[MindBranchEmun.SECOND].main,
  },
  'subchild-1-2': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SECOND].secondary,
    textColor: MindNodeColors[MindBranchEmun.SECOND].default,
    borderColor: MindNodeColors[MindBranchEmun.SECOND].main,
  },

  'subchild-2-0': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.THIRD].secondary,
    textColor: MindNodeColors[MindBranchEmun.THIRD].default,
    borderColor: MindNodeColors[MindBranchEmun.THIRD].main,
  },
  'subchild-2-1': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.THIRD].secondary,
    textColor: MindNodeColors[MindBranchEmun.THIRD].default,
    borderColor: MindNodeColors[MindBranchEmun.THIRD].main,
  },
  'subchild-2-2': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.THIRD].secondary,
    textColor: MindNodeColors[MindBranchEmun.THIRD].default,
    borderColor: MindNodeColors[MindBranchEmun.THIRD].main,
  },

  'subchild-3-0': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FOURTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.FOURTH].default,
    borderColor: MindNodeColors[MindBranchEmun.FOURTH].main,
  },
  'subchild-3-1': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FOURTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.FOURTH].default,
    borderColor: MindNodeColors[MindBranchEmun.FOURTH].main,
  },
  'subchild-3-2': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FOURTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.FOURTH].default,
    borderColor: MindNodeColors[MindBranchEmun.FOURTH].main,
  },

  'subchild-4-0': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIFTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.FIFTH].default,
    borderColor: MindNodeColors[MindBranchEmun.FIFTH].main,
  },
  'subchild-4-1': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIFTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.FIFTH].default,
    borderColor: MindNodeColors[MindBranchEmun.FIFTH].main,
  },
  'subchild-4-2': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.FIFTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.FIFTH].default,
    borderColor: MindNodeColors[MindBranchEmun.FIFTH].main,
  },

  'subchild-5-0': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SIXTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.SIXTH].default,
    borderColor: MindNodeColors[MindBranchEmun.SIXTH].main,
  },
  'subchild-5-1': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SIXTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.SIXTH].default,
    borderColor: MindNodeColors[MindBranchEmun.SIXTH].main,
  },
  'subchild-5-2': {
    ...subchildDefaultStyles,
    bgColor: MindNodeColors[MindBranchEmun.SIXTH].secondary,
    textColor: MindNodeColors[MindBranchEmun.SIXTH].default,
    borderColor: MindNodeColors[MindBranchEmun.SIXTH].main,
  },

  // Sub-subchildren
  'subsubchild-0-0': {
    textColor: MindNodeColors[MindBranchEmun.FIRST].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-0-1': {
    textColor: MindNodeColors[MindBranchEmun.FIRST].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-0-2': {
    textColor: MindNodeColors[MindBranchEmun.FIRST].main,
    ...subSubchildDefaultStyles,
  },

  'subsubchild-1-0': {
    textColor: MindNodeColors[MindBranchEmun.SECOND].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-1-1': {
    textColor: MindNodeColors[MindBranchEmun.SECOND].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-1-2': {
    textColor: MindNodeColors[MindBranchEmun.SECOND].main,
    ...subSubchildDefaultStyles,
  },

  'subsubchild-2-0': {
    textColor: MindNodeColors[MindBranchEmun.THIRD].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-2-1': {
    textColor: MindNodeColors[MindBranchEmun.THIRD].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-2-2': {
    textColor: MindNodeColors[MindBranchEmun.THIRD].main,
    ...subSubchildDefaultStyles,
  },

  'subsubchild-3-0': {
    textColor: MindNodeColors[MindBranchEmun.FOURTH].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-3-1': {
    textColor: MindNodeColors[MindBranchEmun.FOURTH].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-3-2': {
    textColor: MindNodeColors[MindBranchEmun.FOURTH].main,
    ...subSubchildDefaultStyles,
  },

  'subsubchild-4-0': {
    textColor: MindNodeColors[MindBranchEmun.FIFTH].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-4-1': {
    textColor: MindNodeColors[MindBranchEmun.FIFTH].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-4-2': {
    textColor: MindNodeColors[MindBranchEmun.FIFTH].main,
    ...subSubchildDefaultStyles,
  },

  'subsubchild-5-0': {
    textColor: MindNodeColors[MindBranchEmun.SIXTH].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-5-1': {
    textColor: MindNodeColors[MindBranchEmun.SIXTH].main,
    ...subSubchildDefaultStyles,
  },
  'subsubchild-5-2': {
    textColor: MindNodeColors[MindBranchEmun.SIXTH].main,
    ...subSubchildDefaultStyles,
  },
};
